"use client";

import { api } from "../api";
import type { LegalKind } from "../siteConfig";
import type { LegalDocument } from "../types";
import { useAsync, type Async } from "../useAsync";

/*
 * 약관 한 편 (`GET /legal/{kind}`) — `_ui/LegalSheet.tsx` 가 씁니다.
 *
 * 사용: `const doc = useLegal(open ? "terms" : null);  // doc.data?.bodyHtml`
 *
 * 🔑 `kind` 가 `null` 이면 부르지 않습니다 — 시트가 닫혀 있는 동안.
 * 🔑 본문 키는 `bodyHtml`(camelCase 변환)과 `body_html` 둘 다 받습니다.
 */
export function useLegal(kind: LegalKind | null): Async<LegalDocument> {
  return useAsync(
    async (signal) => {
      const raw = await api.get<Record<string, unknown>>(`/legal/${encodeURIComponent(String(kind))}`, { signal });
      const text = (camel: string, snake: string) => {
        const value = raw[camel] ?? raw[snake];
        return typeof value === "string" ? value : "";
      };
      return {
        kind: text("kind", "kind"),
        title: text("title", "title"),
        bodyHtml: text("bodyHtml", "body_html"),
        effectiveOn: text("effectiveOn", "effective_on") || null,
      };
    },
    `legal-${kind}`,
    kind !== null,
  );
}
